import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpandSimple2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconExpandSimple2"><Path fillRule="evenodd" clipRule="evenodd" d="M5.5 12C5.22386 12 5 11.7761 5 11.5V7.5C5 6.11929 6.11929 5 7.5 5H11.5C11.7761 5 12 5.22386 12 5.5C12 5.77614 11.7761 6 11.5 6H7.5C6.67157 6 6 6.67157 6 7.5V11.5C6 11.7761 5.77614 12 5.5 12ZM12 18.5C12 18.2239 12.2239 18 12.5 18H16.5C17.3284 18 18 17.3284 18 16.5V12.5C18 12.2239 18.2239 12 18.5 12C18.7761 12 19 12.2239 19 12.5V16.5C19 17.8807 17.8807 19 16.5 19H12.5C12.2239 19 12 18.7761 12 18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExpandSimple2;
